module.exports = __webpack_public_path__ + "img/contact_bk.e8240e00.png";